/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function() {
    var width = $('body').width();
      if (width > 768) {
        $('#myCarousel').carousel({
          interval: 3000
        });
      } else {
        $('#myCarousel').carousel({
          interval: 0
        })
      }

  $('.carousel .carousel-item').each(function() {
    var width = $('body').width();
    console.log('width', width);
    if (width > 768) {
      var minPerSlide = 3;
      var next = $(this).next();
      if (!next.length) {
        next = $(this).siblings(':first');
      }
      next.children(':first-child').clone().appendTo($(this));

      for (var i = 0; i < minPerSlide; i++) {
        next = next.next();
        if (!next.length) {
          next = $(this).siblings(':first');
        }

        next.children(':first-child').clone().appendTo($(this));
      }
    }
  });

  $('#carousel-example').on('slide.bs.carousel', function(e) {
    var $e = $(e.relatedTarget);
    var idx = $e.index();
    var itemsPerSlide = 5;
    var totalItems = $('.carousel-item').length;

    if (idx >= totalItems - (itemsPerSlide - 1)) {
      var it = itemsPerSlide - (totalItems - idx);
      for (var i = 0; i < it; i++) {
        // append slides to end
        if (e.direction == "left") {
          $('.carousel-item').eq(i).appendTo('.carousel-inner');
        } else {
          $('.carousel-item').eq(0).appendTo('.carousel-inner');
        }
      }
    }
  });
  $('ul.tabs').each(function() {
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function() {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e) {
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
  $('ul.tab').each(function() {
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function() {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e) {
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('[href="#tab-1"]')
    .not('[href="#tab-2"]')
    .not('[href="#tab-3"]')
    .not('[href="#tab-4"]')
    .not('[href="#tab-5"]')
    .not('[href="#tabs-1"]')
    .not('[href="#tabs-2"]')
    .not('[href="#tabs-3"]')
    .not('[href="#tabs-4"]')
    .not('[href="#tabs-5"]')
    .not('[href="#myCarousel"]')
    .click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 100, function() {
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              return false;
            } else {
              $target.attr('tabindex', '-1');
              $target.focus();
            };
          });
        }
      }
    });

 $('a').each(function() {
   var a = new RegExp('/' + window.location.host + '/');
   if (!a.test(this.href)) {
      $(this).attr("target","_blank");
   }
});

  $("div#home-update a[href^=http]").each(function() {
    if (this.href.indexOf(location.hostname) == -1) {
      $(this).attr({
        target: "_blank"
      });
    }
  });

  $("div#Slideshow-slideshow a[href^=http]").each(function() {
    if (this.href.indexOf(location.hostname) == -1) {
      $(this).attr({
        target: "_blank"
      });
    }
  });

  $("div#shopify-section-highlight-cookbook a[href^=http]").each(function() {
    if (this.href.indexOf(location.hostname) == -1) {
      $(this).attr({
        target: "_blank"
      });
    }
  });

  $("div#featured-in a[href^=http]").each(function() {
    if (this.href.indexOf(location.hostname) == -1) {
      $(this).attr({
        target: "_blank"
      });
    }
  });
  setTimeout(function() {
  $('#insta-feed h2:first').wrap( '<a href="https://www.instagram.com/melinadavies11/"></a> ');
}, 500);

});
